// extracted by mini-css-extract-plugin
module.exports = {"Search":"SearchBar_Search__1ZpJ_"};